"use strict";
const angular = require("angular");
const debug = require("debug")("fifi:app");
const uiRouter = require("angular-ui-router");

import routes from "./application.routes";

export class ApplicationComponent {
  preventSubmit = false;

  /*@ngInject*/
  constructor(
    Auth,
    $rootScope,
    $http,
    stripe,
    $state,
    $stateParams,
    $document,
    Applications,
    Fake,
    EnvironmentConfig,
    Cars
  ) {
    console.log("APPCOMP");
    this.loaded = false;
    let that = this;
    debug("Reached ApplicationComponent");
    debug(EnvironmentConfig);
    debug(this.settings);
    debug($stateParams);
    this._stripe = stripe; //Initialize Stripe
    this._$state = $state;
    this._$http = $http;
    this._$document = $document;
    this._Auth = Auth;

    this._Applications = Applications;
    this._Cars = Cars;

    // if(!this.settings.enableMainForm && !Auth.isAdminSync()) {
    //   $state.go('main');
    // } else {
    //   this.loaded = true;
    // }
    $rootScope.$$listeners.$stateChangeStart = [];
    $rootScope.$on("$stateChangeStart", function (
      event,
      toState,
      toParams,
      fromState
    ) {
      debug("stateChangeStart");
      debug(fromState.name, toState.name);
      that.error = "";
      if (
        fromState.name == "application.complete" &&
        toState.name == "application.review"
      ) {
        // console.log('G0t0 c0ntact');
        // that._$state.go('application.contact');
        event.preventDefault();
        that.resetStatus();
        that.resetPayment();
        that.application = {};
        that._$state.go("application.contact");
      }
    });

    // this.settings = {};

    // $http.get('/api/settings/')
    //   .then(response => {
    //     for(let setting of response.data) {
    //       this.settings[setting.name] = setting.value;
    //     }
    //   });

    this.preventPayment = false;

    this.steps = {
      contactForm: {
        next: "application.mailing",
        status: true,
      },
      mailingForm: {
        next: "application.beach",
        status: false,
      },
      paymentForm: {
        next: "application.review",
        status: false,
      },
      agreementForm: {
        next: "application.payment",
        status: false,
      },
      beachForm: {
        next: "application.vehicle",
        status: false,
      },
      vehicleForm: {
        next: "application.agreement",
        status: false,
      },
      review: {
        status: false,
      },
      complete: {
        status: false,
      },
    };

    this.returnData = {};

    this.topLocation = 40;
    this.scrollDuration = 800;

    this.error = null;

    this.makeList = [];
    this.modelList = [];

    // Create array of years for car data
    this.yearStart = 1959;
    this.today = new Date();
    this.yearEnd = this.today.getYear() + 1900 + 1; //Current year + 1 for car models.
    this.years = [];
    // this.thisYear = this.today.getYear() - 100;
    // this.maxExpYear = this.today.getYear() - 60;

    // this.exp_months = [];
    // this.exp_years = [];

    this.communityConflict = false;
    this.communityWarning = "";

    // Fill in dummy data if environment is dev
    if ($stateParams.homeownerApp) {
      this.application = {};
      this.application = angular.copy($stateParams.homeownerApp);
      // this.application = $stateParams.homeownerApp;
    } else if (EnvironmentConfig.environment == "development") {
      this.application = {};
      this.application = Fake.fakeApp();
      this.application.vehicle.make = null;
      this.application.vehicle.model = null;
      this.application.vehicle.year = null;
    } else {
      this.application = {};
    }

    this.payment = {};

    this.seqArray(this.yearStart, this.yearEnd, this.years, false);
    // this.seqArray(0, 12, this.exp_months, true);
    // this.seqArray(this.thisYear - 1, this.maxExpYear, this.exp_years, true);

    this.checkState();
  }

  $onInit() {
    console.log("testInit");
    if (!this.settings.enableMainForm && !this._Auth.isAdminSync()) {
      console.log("going places");
      this._$state.go("main");
    } else {
      this.loaded = true;
    }
  }

  fillBilling() {
    this.payment.address_line1 = this.application.address.line1;
    this.payment.address_line2 = this.application.address.line2;
    this.payment.address_city = this.application.address.city;
    this.payment.address_state = this.application.address.state;
    this.payment.address_zip = this.application.address.zip;
  }

  submitForm(form) {
    debug("test6:", form);
    // if(form.$valid) {
    if (form.$name == "paymentForm") {
      return this.getToken();
    }
    debug(form.$name);
    this.steps[form.$name].status = true;
    debug("Next: ", this.steps[form.$name].next);
    this._$state.go(this.steps[form.$name].next);
    this._$document.scrollTop(this.topLocation, this.scrollDuration);
    // }
  }

  startApp() {
    this.resetStatus();
    this.resetPayment();
    this.application = {};
    this._$state.go("main");
  }

  submitApplication() {
    if (!this.application.name.first || !this.application.name.last) {
      this.error = "You must enter your full name.";
      return;
    } else if (
      !this.application.contact.email ||
      !this.application.contact.primaryPhone
    ) {
      this.error = "You must enter both an email address and phone number.";
      return;
    } else if (
      !this.application.address.line1 ||
      !this.application.address.city ||
      !this.application.address.state ||
      !this.application.address.zip
    ) {
      this.error = "You must enter a proper mailing address.";
      return;
    } else if (
      !this.application.beach.community ||
      !this.application.beach.type
    ) {
      this.error = "You must enter both your community and type of property.";
      return;
    }

    this.preventSubmit = true;

    debug(this.application);

    this._Applications.save(this.application).then(
      (response) => {
        this.steps.review.status = true;
        this.error = null;
        this.returnData = response;
        this._$state.go("application.complete");
        this._$document.scrollTop(this.topLocation, this.scrollDuration);
        this.steps.complete.status = true;
        this.application = {};
        this.preventSubmit = false;
      },
      (err) => {
        console.log(err);
        this.error = err.data.message;
        if (!err.data.message) {
          this.error = "Please check all information and try again.";
        }
        this.preventSubmit = false;
      }
    );
  }

  updateVehicleInfo() {
    if (this.application.vehicle.raw) {
      this.application.vehicle.model = this.application.vehicle.raw.model;
      this.application.vehicle.size = this.application.vehicle.raw.oversized
        ? "Oversized"
        : "Normal";
    }
  }

  updateCars(mode) {
    if (mode == "year") {
      this.modelList = [];
      this.makeList = [];
      this.application.vehicle.make = null;
      this.application.vehicle.model = null;
    }
    this._Cars
      .getCarList(this.application.vehicle.year, this.application.vehicle.make)
      .then((response) => {
        if (mode === "year") {
          this.makeList = response;
          this.modelList = [];
        } else {
          this.modelList = response;
          this.modelList.push({ model: "Other", oversized: false });
        }
      });
  }

  resetStatus() {
    for (var prop in this.steps) {
      if (prop != "contactForm") {
        this.steps[prop].status = false;
      }
    }
  }

  checkCommunity() {
    var beach = this.application.beach.community;
    var type = this.application.beach.type;
    var obOverride = this.application.obOverride;
    let westLot = beach == "SV" || beach == "PK";
    let obHO = beach == "OB" && type == "Homeowner";
    let saHO = beach == "SA" && type == "Homeowner";
    let misc = !westLot && !obHO && !saHO;

    this.preventPayment = false;
    if (westLot && this.settings.westFull) {
      debug("West Full");
      this.preventPayment = true;
    } else if (obHO && this.settings.obhoFull) {
      this.preventPayment = true;
      debug("OBHO Full");
    } else if (this.settings.mainFull && misc) {
      this.preventPayment = true;
      debug("Main Full");
      // console.log('Check if main lot is full.');
    }

    // console.log(this.preventPayment);

    if (beach == "OB" && type == "Homeowner" && !obOverride) {
      this.communityWarning = `This application is not the Ocean Beach
        homeowner application.  This application is for other communities,
        businesses, and for additional parking spots.
        The Ocean Beach homeowner applications will be available online at a later date.
        You will recieve an application ID via e-mail to allow you to complete the application on that date.`;
      this.communityConflict = true;
    } else if (beach == "SA" && type == "Homeowner") {
      this.communityWarning = `This application is not the Saltaire
        homeowner application.  This application is for other communities,
        businesses, and for additional parking spots.
        The Saltaire homeowner applications will be available online at a later date. You will recieve an application ID via e-mail to allow you to complete the application on that date.`;
      this.communityConflict = true;
    } else {
      this.communityConflict = false;
    }
  }

  checkState() {
    debug("Check State");
    if (
      this._$state.current.name != "application.contact" &&
      !this.application.address
    ) {
      debug("Contact is empty!");
      this._$state.go("application.contact");
    }
  }

  getToken() {
    if (this.application.charge || this.preventPayment) {
      return this._$state.go("application.review");
    }

    // console.log(this.payment);
    return this._stripe.card
      .createToken(this.payment)
      .then((response) => {
        this.error = null;
        debug("token created for card ending in " + response.card.last4);
        //  var payment = angular.copy(this.payment);
        this.payment.number = void 0;
        this.payment.cvc = void 0;
        this.payment.exp_month = void 0;
        this.payment.exp_year = void 0;
        this.payment.token = response.id;
        debug(response);
        //  console.log(this.payment);

        this.application.ip = response.client_ip;

        this.application.charge = {
          token: response.id,
          cardholder: response.card.name,
          billing: {
            line1: response.card.address_line1,
            line2: response.card.address_line2,
            city: response.card.address_city,
            state: response.card.address_state,
            zip: response.card.address_zip,
          },
          cardId: response.card.id,
          last4: response.card.last4,
          brand: response.card.brand,
        };
        this.steps.paymentForm.status = true;
        this._$state.go("application.review");
        this._$document.scrollTop(this.topLocation, this.scrollDuration);
      })
      .catch((err) => {
        if (err.type && /^Stripe/.test(err.type)) {
          console.log("Stripe error: ", err.message);
          this.error = err.message;
        } else {
          console.log(
            "Other error occurred, possibly with your API",
            err.message
          );
          this.error = err.message;
        }
      });
  }

  resetPayment() {
    this.application.charge = null;
    this.payment = {};
  }

  calculatePrice() {
    this.checkCommunity();
    let standardPrice;
    if (
      this.application.beach.community == "OB" &&
      this.application.beach.type == "Homeowner"
    ) {
      standardPrice = this.settings.obhoPrice;
    } else if (
      this.application.beach.community == "SA" &&
      this.application.beach.type == "Homeowner"
    ) {
      standardPrice = this.settings.sahoPrice;
    } else {
      standardPrice = this.settings.miscPrice;
    }
    this.price = {
      standard: standardPrice,
      oversizedFee: 0,
      processingFee: 0,
      total: 0,
    };
    if (this.application.vehicle.size === "Oversized") {
      this.price.oversizedFee = this.settings.oversizedFee;
    }
    this.price.processingFee =
      (this.price.standard + this.price.oversizedFee) *
      this.settings.processingFee;
    this.price.total =
      this.price.standard + this.price.oversizedFee + this.price.processingFee;
    return this.price;
  }

  seqArray(start, end, array, dir) {
    for (var i = end; i > start; i--) {
      if (dir) {
        array.unshift(i);
      } else {
        array.push(i);
      }
    }
    return array;
  }
}

export default angular
  .module("parkingformApp.application", [uiRouter])
  .config(routes)
  .component("application", {
    template: require("./application.html"),
    controller: ApplicationComponent,
    controllerAs: "form",
    bindings: {
      settings: "<",
    },
  }).name;



// WEBPACK FOOTER //
// ./client/app/application/application.component.js